import { Trans } from "@lingui/macro";
import { NavBar } from "@src/components/ui-kit";

export const CreditAccountsTypeLinks = () => {
  return (
    <>
      <NavBar.Item href="/invoices/credit-accounts">
        <Trans>Brand</Trans>
      </NavBar.Item>
      <NavBar.Item href="/credit-accounts/global">
        <Trans>Expense</Trans>
      </NavBar.Item>
    </>
  );
};
